import './BulletLabel.css';

type BulletSize = 'xxSmall' | 'xSmall' | 'small' | 'medium' | 'large';

interface BulletLabelProps {
  children: React.ReactNode;
  color?: string;
  size?: BulletSize;
}

const sizeMap: Record<BulletSize, number> = {
  xxSmall: 4,
  xSmall: 6,
  small: 8,
  medium: 12,
  large: 16,
};

function BulletLabel({
  color = '--color-foreground-neutral-bold',
  children,
  size = 'small',
}: BulletLabelProps) {
  // Convert CSS variable name to full `var(--name)` syntax
  const resolvedColor = color.startsWith('var(') ? color : `var(${color})`;

  return (
    <div className='BulletLabel'>
      <span
        className='BulletLabel-bullet'
        style={{
          backgroundColor: resolvedColor,
          width: sizeMap[size],
          height: sizeMap[size],
        }}
      />
      <span className='BulletLabel-text'>{children}</span>
    </div>
  );
}

export default BulletLabel;
